// import PropTypes from 'prop-types';
import React from 'react';
import PropTypes from 'prop-types';
import { ButtonBase } from '../../Common/Component/Forms';
import { AddToCartStyled } from './AddToCartStyled';
import { IC_DELETE_HC } from '../../Common/Assets/images';
import useCartItemChecker from '../Hooks/UseCartItemChecker';

const AddToCart = (props) => {
  const isItemAddedToCart = useCartItemChecker(props?.itemHisId);

  return (
    <AddToCartStyled className={props?.className}>
      {isItemAddedToCart ? (
        <ButtonBase
          data-test="AddToCartButton"
          outerCustomClass={`btn-base ${props?.className}`}
          customClass="btn-inner btn-primary btn-sm btn-added"
          minWidth={props?.minWidth}
          rightIconOuterClass="ic-added"
          text="Added"
          icon={IC_DELETE_HC}
          iconClass="ic-delete"
          iconWidth="12px"
          iconHeight="14px"
          iconPosition="right"
          textClass="btn-text"
          onClick={(event) => event.stopPropagation()}
          onIconClick={(e) => props.deleteFromCartService(e)}
        />
      ) : (
        <ButtonBase
          data-test="AddToCartButton"
          outerCustomClass={`btn-base ${props?.className}`}
          customClass="btn-inner btn-primary btn-sm"
          disabled={!props?.isServiceable || props?.nextavailableslot === null || !props?.salePriceValue}
          minWidth={props?.minWidth}
          text="Add"
          onClick={(e) => props.addToCartService(e)}
        />
      )}
    </AddToCartStyled>
  );
};

AddToCart.propTypes = {
  minWidth: PropTypes.string,
  className: PropTypes.string,
  addToCartService: PropTypes.func,
  deleteFromCartService: PropTypes.func,
  itemHisId: PropTypes.string,
  isServiceable: PropTypes.bool,
  nextavailableslot: PropTypes.any,
  salePriceValue: PropTypes.bool
};

AddToCart.defaultProps = {
  minWidth: '118px',
  className: '',
  addToCartService: () => {},
  deleteFromCartService: () => {},
  itemHisId: '',
  isServiceable: true,
  salePriceValue: true,
};

export default AddToCart;
